<p [innerHTML]="'BOOKING.OTHER_CAMPS.DESCRIPTION' | translate" class="u-m-bottom--md"></p>

<div class="grey-block u-m-bottom--md">
	<p class="u-m-bottom--sm">
		{{ 'BOOKING.OTHER_CAMPS.SECOND' | translate }}
		<span class="u-text--sm u-text--grey-blue">(optioneel)</span>
	</p>
	<ivva-camp-form [priority]="2"></ivva-camp-form>
</div>

<div class="grey-block">
	<p class="u-m-bottom--sm">
		{{ 'BOOKING.OTHER_CAMPS.THIRD' | translate }}
		<span class="u-text--sm u-text--grey-blue">(optioneel)</span>
	</p>
	<ivva-camp-form [priority]="3"></ivva-camp-form>
</div>
